export const L10N = {
  LABEL_HANG_UP: { id: 'lisa.label.hang_up' },
  LABEL_CALLING: { id: 'lisa.label.calling' },
};
